package gr.tech.pdfgenerator.models

import gr.tech.pdfgenerator.util.formatCurrency

data class DerivationsDTO(
    var electricityRate: Double = 0.0,
    var annualKWHSaved: Long = 0,
    var energySavingsLighting: Long = 0,
    var energySavingsHVAC: Long = 0,
    var maintenanceSavings: Long = 0,
) {
    override fun toString(): String {
        return """
            |DerivationsDTO(
            |  Electricity Rate ($/kWh)     : $electricityRate
            |  Annual kWh Saved             : $annualKWHSaved
            |  Energy Savings - Lighting    : ${formatCurrency(energySavingsLighting)}
            |  Energy Savings - HVAC        : ${formatCurrency(energySavingsHVAC)}
            |  Maintenance Savings          : ${formatCurrency(maintenanceSavings)}
            |)
        """.trimMargin()
    }
}